import { StringHelper } from "../../../utilities/contracts/string-helper";
import { MemberChartItem } from "./member-chart-item.model";

export class MemberChartM360Response {
  readonly chartMetadatas?: MemberChartItem[];
  readonly paginationToken?: string;

  constructor(options: Partial<MemberChartM360Response> = {}) {
    this.chartMetadatas = options.chartMetadatas;
    this.paginationToken = StringHelper.clean(options.paginationToken);
  }
}
